<template>
  <div class="exercises-cardio-tab-nav">
    <div
      v-for="(cardioExercise, index) in cardioExercises"
      :key="index"
      class="tab-item has-data"
      :class="{ active: index === activeIndex }"
      :style="{ width: tabWidth }"
      @click="$emit('update:active-index', index)"
    >
      <div class="text">{{ cardioExercise.exerciseName | withDefault }}</div>
    </div>
    <div v-if="isEditable" class="tab-item add" @click="$emit('add-item')">
      <v-icon color="primary">add</v-icon>
    </div>
  </div>
</template>

<script>
import { withDefault } from '@/components/exercises/measure/filters'

export default {
  filters: {
    withDefault,
  },
  props: {
    cardioExercises: {
      type: Array,
      required: true,
    },
    activeIndex: {
      type: Number,
      required: true,
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tabWidth() {
      if (this.isEditable) {
        return `calc(${100 / this.cardioExercises.length}% - 44px / ${this.cardioExercises.length})`
      } else {
        return `calc(${100 / this.cardioExercises.length}%)`
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.exercises-cardio-tab-nav {
  display: flex;
  overflow-y: hidden;
  margin-bottom: -1px;
  margin-left: -1px;
}

.tab-item {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  display: flex;
  align-items: center;
  font-size: 13px;
  flex-basis: fit-content;
  max-width: 18em;
  transition: opacity 0.15s, bold 0.15s;
  padding: 8px 12px;

  &.has-data {
    background-color: darken(white, 2%);
    border: 1px solid darken(white, 4%);
    border-bottom: 0;
    cursor: pointer;
    flex-grow: 1;
    margin-bottom: 1px;
    opacity: 0.92;

    &:not(:first-child) {
      border-left: 0;
    }
  }

  &.active {
    background-color: white;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.06);
    border-bottom: 0;
    position: relative;
    z-index: 1;
    font-weight: 600;
    margin-bottom: 0;
    opacity: 1;
  }

  &.add {
    background-color: get-hover-bg-color($color-primary);
    margin-bottom: 1px;
    border-top-left-radius: 0;
    padding: 6px 10px;
    cursor: pointer;
    position: relative;

    &:before {
      content: '';
      width: 4px;
      position: absolute;
      left: -4px;
      background-color: get-hover-bg-color($color-primary);
      top: 0;
      bottom: 0;
    }
  }
}

.text {
  min-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
